import { jsxs as i, jsx as a, Fragment as L } from "react/jsx-runtime";
import { c as r } from "../../../../clsx-OuTLNxxd.js";
import { u as O } from "../../../../downshift.esm-B5WCuwFD.js";
import { useState as x, useEffect as k, useMemo as A } from "react";
import { I as h } from "../../../../icon-B72I4fRl.js";
import "../../icon/iconsList.js";
import { AlternativeAction as B } from "./alternativeAction/alternativeAction.js";
const D = "_disabled_1tqw2_74", G = "_hidden_1tqw2_137", J = "_highlight_1tqw2_153", e = {
  "autocomplete-container": "_autocomplete-container_1tqw2_29",
  "full-width": "_full-width_1tqw2_32",
  "input-container": "_input-container_1tqw2_41",
  "has-error": "_has-error_1tqw2_50",
  "label-helper-text": "_label-helper-text_1tqw2_53",
  "input-block": "_input-block_1tqw2_58",
  disabled: D,
  "error-text": "_error-text_1tqw2_116",
  "suggestions-container": "_suggestions-container_1tqw2_125",
  hidden: G,
  "has-alternative-action": "_has-alternative-action_1tqw2_140",
  "alternative-action-container": "_alternative-action-container_1tqw2_153",
  highlight: J,
  "item-block": "_item-block_1tqw2_156",
  "no-suggestion": "_no-suggestion_1tqw2_167",
  "has-href": "_has-href_1tqw2_178",
  "alternative-action-container-wrapper": "_alternative-action-container-wrapper_1tqw2_181"
}, $ = ({
  onChange: S,
  onSelect: P,
  suggestions: n = [],
  inputValue: l,
  noSuggestionText: T,
  placeholder: u,
  label: d,
  labelHelperContent: m,
  inputIcon: p,
  itemsIcon: c,
  disabled: w = !1,
  hasError: _ = !1,
  errorText: z,
  alternativeAction: o,
  isFullWidth: V = !1
}) => {
  const [g, y] = x(l || ""), [f, b] = x(!1), {
    isOpen: C,
    getMenuProps: j,
    getInputProps: I,
    getLabelProps: M,
    getItemProps: v,
    highlightedIndex: q,
    setInputValue: N
  } = O({
    items: n,
    initialInputValue: l,
    onInputValueChange: ({ inputValue: t }) => {
      const s = t || "";
      y(s), S?.(s);
    },
    itemToString: (t) => t?.value || "",
    onSelectedItemChange: ({ selectedItem: t }) => {
      t && P?.(t.value);
    }
  });
  k(() => {
    l !== void 0 && N(l);
  }, [l, N]), k(() => {
    if (g && n.length === 0) {
      b(!0);
      const t = setTimeout(() => {
        b(!1);
      }, 500);
      return () => clearTimeout(t);
    }
  }, [g, n]);
  const R = C && (n.length > 0 || f), F = A(
    () => n.map((t, s) => /* @__PURE__ */ i(
      "li",
      {
        className: r(c && e["item-block"], q === s && e.highlight),
        ...v({ item: t, index: s }),
        children: [
          c && /* @__PURE__ */ a(h, { name: c, size: "large" }),
          t.value
        ]
      },
      t.id
    )),
    [n, q, c, v]
  );
  return /* @__PURE__ */ i("div", { className: r(e["autocomplete-container"], V && e["full-width"]), children: [
    /* @__PURE__ */ i("div", { className: e["input-container"], children: [
      d && /* @__PURE__ */ i(L, { children: [
        /* @__PURE__ */ a("label", { className: r(_ && e["has-error"]), ...M(), children: d }),
        m && /* @__PURE__ */ a("div", { className: e["label-helper-text"], children: m })
      ] }),
      /* @__PURE__ */ i("div", { className: e["input-block"], children: [
        p && /* @__PURE__ */ a(h, { className: r(w && e.disabled), name: p, size: "large" }),
        /* @__PURE__ */ a(
          "input",
          {
            className: r(_ && e["has-error"]),
            type: "text",
            ...u && { placeholder: u },
            ...I({ disabled: w })
          }
        )
      ] }),
      _ && /* @__PURE__ */ i("div", { className: e["error-text"], children: [
        /* @__PURE__ */ a(h, { name: "error-warning-fill", size: "large", color: "error" }),
        z
      ] })
    ] }),
    /* @__PURE__ */ a(
      "div",
      {
        className: r(
          e["suggestions-container"],
          o && e["has-alternative-action"],
          !R && e.hidden
        ),
        children: /* @__PURE__ */ i("ul", { ...j(), children: [
          n.length > 0 ? F : f && /* @__PURE__ */ a("li", { className: e["no-suggestion"], children: T }),
          o && /* @__PURE__ */ a("li", { className: r(e["alternative-action-container"], o.href && e["has-href"]), children: /* @__PURE__ */ i("div", { className: e["alternative-action-container-wrapper"], children: [
            /* @__PURE__ */ a(h, { name: "pencil", size: "large", color: "secondary" }),
            /* @__PURE__ */ a(
              B,
              {
                alternativeAction: o.text,
                href: o.href,
                openNewTab: o.openNewTab,
                onAlternativeAction: o.action
              }
            )
          ] }) })
        ] })
      }
    )
  ] });
};
export {
  $ as Autocomplete
};
